import { basic } from 'api';
import {
  UI_SET_LOADER,
  UI_SET_LOADER_TEXT,
  SET_UI_PROPERTY,
  GET_MARKDOWN_FILE
} from 'store/actions/ui';

export default {
  [UI_SET_LOADER]: ({ commit }, loading) => {
    commit(UI_SET_LOADER, loading);
  },

  [UI_SET_LOADER_TEXT]: ({ commit }, text) => {
    commit(UI_SET_LOADER_TEXT, text);
  },

  [SET_UI_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_UI_PROPERTY, {
      field,
      value
    }),

  [GET_MARKDOWN_FILE]: ({ commit, getters }, { url, field }) =>
    new Promise((resolve, reject) => {
      if (!getters.dataUI(field)) {
        basic.getMarkdownFile(url).then(
          resp => {
            const data = resp.data;
            commit(SET_UI_PROPERTY, {
              field,
              value: data
            });
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        );
      } else {
        resolve();
      }
    })
};
